import React from "react";

export default function DriversSkeleton({ count = 8 }) {
  const items = Array.from({ length: count });
  return (
    <div className="w-full">
      <div className="grid gap-6 grid-cols-1 py-2 lg:h-[calc(100vh-10rem)] overflow-y-auto pb-5 animate-pulse">
        {items.map((_, i) => (
          <div
            key={i}
            className="bg-white rounded-xl border  border-gray-300 shadow-sm overflow-hidden p-2 md:p-3 flex flex-col max-sm:flex-row h-[80px] w-full max-sm:w-full"
          >
          

            <div className="p-3 flex flex-col gap-2 flex-1 max-sm:order-1">
              <div className="flex items-center gap-3">
                <div className="h-12 w-12 rounded-full bg-gray-300 flex-shrink-0" />
                <div className="flex flex-col gap-2">
                  <div className="h-5 w-48 md:w-56 bg-gray-300 rounded mb-1" />
                  <div className="h-3 w-36 bg-gray-300 rounded" />
                </div>
              </div>

            

      
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
